import {
  CartCheckoutClient,
  ResponseError,
} from '@app/data/clients/cartCheckoutClient';
import {
  DispatchActionsType,
  StateDispatch,
} from '@app/data/clients/cartCheckoutClient/CartAndDeliveryDatesDataContext/types';
import {
  ApplyCouponHandlerOptions,
  ApplyCouponHandlerResult,
} from '@app/types/cart/Coupon';
import { isApplyCouponAPISuccess } from '@app/types/monolith/utils';
import { useCallback, useState } from 'react';

const formatApplyCouponError = (error: {
  error_code?: string;
  error_params?: Record<string, string>;
}) => {
  const field = ['cart', 'coupon'];
  return { ...error, field };
};

export const useApplyCouponHandler = (
  client: CartCheckoutClient,
  dispatch: StateDispatch
): ApplyCouponHandlerResult => {
  const [isLoading, setIsLoading] = useState(false);

  const handler = useCallback(
    async (options: ApplyCouponHandlerOptions) => {
      setIsLoading(true);

      return client
        .applyCoupon(options.input, options.signal)
        .then((monolithRes) => {
          if (isApplyCouponAPISuccess(monolithRes)) {
            dispatch({
              type: DispatchActionsType.SET_CART,
              payload: monolithRes.cart,
            });
            options.onCompleted?.({ errors: [] });
          } else {
            options.onCompleted?.({
              errors: [formatApplyCouponError(monolithRes)],
            });
          }
        })
        .catch((error) => {
          if (error instanceof ResponseError) {
            options.onError?.({ responseError: error });
            return;
          }
          options.onError?.({});
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [client.applyCoupon, dispatch]
  );

  return {
    handler,
    isLoading,
  };
};
